// Shared status/date utilities for SafetyDesk81 frontend.
// Mirror of backend/stato_utils.py — keep the two files in sync.
//
// All date comparisons are done using calendar dates (Y-M-D) in the
// user's local timezone, treating the input ISO string as a Europe/Rome
// calendar date. The current date is calculated dynamically on every
// call so KPIs refresh across midnight without a manual reload.

export const DEFAULT_WARN_DAYS = 30;

// Return today's date in Europe/Rome as a plain 'YYYY-MM-DD' string.
export const todayRome = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Rome',
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(new Date());
  const y = parts.find((p) => p.type === 'year').value;
  const m = parts.find((p) => p.type === 'month').value;
  const d = parts.find((p) => p.type === 'day').value;
  return `${y}-${m}-${d}`;
};

// Parse "YYYY-MM-DD" (or an ISO datetime) into an integer day-count so
// comparisons are exact and immune to DST/UTC shifts.
export const parseDayNumber = (iso) => {
  if (!iso) return null;
  const s = String(iso).slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return null;
  const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
  if (!y || !mo || !d) return null;
  // Days since 1970-01-01 using Date.UTC (no timezone drift).
  return Math.floor(Date.UTC(y, mo - 1, d) / 86400000);
};

const todayDayNumber = () => parseDayNumber(todayRome());

// Signed distance in days from today to `iso`. Negative → past.
export const daysUntil = (iso) => {
  const t = todayDayNumber();
  const d = parseDayNumber(iso);
  if (t === null || d === null) return null;
  return d - t;
};

/**
 * Compute stato bucket for a scadenza.
 *   scadenza < today                       -> "scaduto"
 *   today <= scadenza <= today + warnDays  -> "in_scadenza"
 *   scadenza > today + warnDays            -> "valido"
 *   missing / malformed                    -> null
 */
export const computeStato = (scadenza, warnDays = DEFAULT_WARN_DAYS) => {
  const delta = daysUntil(scadenza);
  if (delta === null) return null;
  if (delta < 0) return 'scaduto';
  if (delta <= warnDays) return 'in_scadenza';
  return 'valido';
};

// Female form used for visite mediche.
export const computeStatoVisita = (scadenza, warnDays = 90) => {
  const s = computeStato(scadenza, warnDays);
  if (s === 'valido') return 'valida';
  if (s === 'scaduto') return 'scaduta';
  return s;
};
